import React, { useEffect, useState } from 'react';
import { ScanSearch } from 'lucide-react';

const DEFAULT_ETA_S = 25;

// Barra de progresso da detecção de janelas (IA): anima até ~95% dentro do tempo estimado e segura até o status mudar.
export const DetectProgress = ({ startedAt, etaS = DEFAULT_ETA_S, label, remainingLabel, almostLabel, compact = false, testId = 'detect-progress' }) => {
  const [now, setNow] = useState(Date.now());
  useEffect(() => { const id = setInterval(() => setNow(Date.now()), 500); return () => clearInterval(id); }, []);
  const t0 = startedAt ? new Date(startedAt).getTime() : now;
  const eta = Math.max(5, Number(etaS) || DEFAULT_ETA_S);
  const elapsed = Math.max(0, (now - t0) / 1000);
  const pct = Math.min(95, Math.round((elapsed / eta) * 95));
  const remaining = Math.max(0, Math.ceil(eta - elapsed));
  const sub = remaining > 0 ? remainingLabel(remaining) : almostLabel;
  return (
    <div className={`w-full ${compact ? 'space-y-0.5' : 'space-y-1'}`} data-testid={testId}>
      <div className={`flex items-center justify-between gap-2 ${compact ? 'text-[10px]' : 'text-[11px]'} font-bold`}>
        <span className="inline-flex items-center gap-1 truncate"><ScanSearch className="h-3.5 w-3.5 animate-pulse shrink-0" /> {label}</span>
        <span className="tabular-nums whitespace-nowrap font-semibold opacity-80" data-testid={`${testId}-eta`}>{sub}</span>
      </div>
      <div className={`${compact ? 'h-1' : 'h-1.5'} w-full rounded-full bg-black/10 overflow-hidden`}>
        <div className="h-full rounded-full bg-teal-500 transition-[width] duration-500 ease-linear" style={{ width: `${pct}%` }} data-testid={`${testId}-bar`} />
      </div>
    </div>
  );
};
